// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminReviews = (client) => ({
    /**
     * `GET /admin/reviews`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListReviews
     * @source packages/modules/reviews/src/api/admin/reviews/route.ts
     */
    list: (query, headers) => client.fetch("/admin/reviews", { method: "GET", query, headers }),
    /**
     * `GET /admin/reviews/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetReviewById
     * @source packages/modules/reviews/src/api/admin/reviews/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/reviews/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=reviews.js.map